import "./DataCollection.css";
import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import TextInput from "./Inputs/TextInput";
import SINInput from "./Inputs/SINInput";
import DropdownInput from "./Inputs/DropdownInput";
import LabeledBooleanInput from "./Inputs/LabeledBooleanInput";
import DateInput from "./Inputs/DateInput";
import { handleChange, sinValidation } from "../Utils/DataCollectionUtils";
import { useTranslation } from "react-i18next";
import { GENDERS, PROVINCES } from "../Utils/PlanUtils";
import { useParams } from "react-router-dom";

const GuardianDataCollection = ({ state }) => {
    const params = useParams();
    const { t } = useTranslation();
    const application = state.application;
    const setApplication = state.setApplication;

    return (
        <form>
            <InputRowGroup label={t("Primary Care Giver")}>
                <InputRow label={t("Name")}>
                    <TextInput
                        placeholder={t("Given Name")}
                        name={"custodianFirstName"}
                        state={application}
                        onChange={handleChange(setApplication)}
                        autoFocus={params.item === 'custodian.givenName'}
                    />
                    <TextInput
                        placeholder={t("Middle Name")}
                        name={"custodianMiddleName"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                    <TextInput
                        placeholder={t("Last Name")}
                        name={"custodianLastName"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>

                <InputRow label={t("Title")} presetValues={
                    [
                        t("Mr"),
                        t("Mrs"),
                        t("Miss"),
                        t("Ms"),
                        t("Dr"),
                    ]
                } onPresetSelected={(preset) => {
                    setApplication({
                        ...application,
                        custodianTitle: preset
                    });
                }}>
                    <TextInput
                        placeholder={t("Title")}
                        name={"custodianTitle"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>

                <InputRow label={t("Social Insurance Number")}>
                    <SINInput
                        placeholder={t("Social Insurance Number")}
                        name={"custodianSIN"}
                        state={application}
                        onChange={handleChange(setApplication)}
                        vasinValidation={sinValidation}
                    />
                </InputRow>

                <InputRow label={t("Gender")}>
                    <DropdownInput
                        state={application}
                        name={'gender'}
                        onChange={handleChange(setApplication, false)}
                        options={GENDERS}
                    />
                </InputRow>

                <InputRow label={t("Address")}>
                    {/*custodianStreetNumber, custodianAddress, custodianSuite, custodianPobox*/}
                    <TextInput
                        placeholder={t("Number")}
                        name={"custodianStreetNumber"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                    <TextInput
                        placeholder={t("Street")}
                        name={"custodianAddress"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                    <TextInput
                        placeholder={t("Suite")}
                        name={"custodianSuite"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                    <TextInput
                        placeholder={t("PO Box")}
                        name={"custodianPobox"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>

                <InputRow label={t("City")}>
                    <TextInput
                        placeholder={t("City")}
                        name={"custodianCity"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>

                {/* provence dropdown*/}
                <InputRow label={t("Province")}>
                    <DropdownInput state={application}
                        name={"custodianProvince"}
                        onChange={handleChange(setApplication)}
                        options={PROVINCES} selectionLabel={t("select province")}
                    />
                </InputRow>

                {/* country */}
                <InputRow label={t("Country")}>
                    <TextInput
                        placeholder={t("Country")}
                        name={"custodianCountry"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>

                {/* Postal code */}
                <InputRow label={t("Postal Code")}>
                    <TextInput
                        placeholder={t("Postal Code")}
                        name={"custodianPostalCode"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>

                {/* E-Mail */}
                <InputRow label={t("E-Mail Address")}>
                    <TextInput
                        placeholder={t("E-Mail Address")}
                        name={"custodianEmail"}
                        state={application}
                        onChange={handleChange(setApplication)}
                        autoFocus={params.item === 'application.custodianEmail'}
                    />
                </InputRow>

                <InputRow label={t('Mobile Phone Number')}>
                    +1
                    <TextInput
                        placeholder={t('Mobile Phone Number')}
                        name={'custodianMobilePhone'}
                        state={state.application}
                        onChange={handleChange(state.setApplication)}
                        validationRules={{
                            pattern: {
                                value: /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/
                            }
                        }}
                        autoFocus={params.item === 'application.custodianMobilePhone'}
                        validationFailedMessage={'The phone number entered was invalid'}
                    />
                    <div className={'info'}>
                        {t("As a security precaution, a text message may be sent to this number during the signing process to verify the identity of the guardian.")}
                    </div>
                </InputRow>

                <InputRow label={t("Signing Method")}>
                    <DropdownInput
                        name={'custodianInPersonSigner'}
                        state={state.application}
                        onChange={handleChange(state.setApplication)}
                        options={[{ label: t('In Person'), value: true }, { label: t('Remote'), value: false }]}
                        booleanValue={true}
                    />
                </InputRow>
            </InputRowGroup>

            {/* Custodial Parent */}
            <InputRowGroup label={t("Custodial Parent")}>
                <InputRow label={t("Name")}>
                    <TextInput
                        placeholder={t("Given Name")}
                        name={"custodialParentFirstName"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                    <TextInput
                        placeholder={t("Last Name")}
                        name={"custodialParentLastName"}
                        state={application}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>
            </InputRowGroup>
        </form>
    );
};

export default GuardianDataCollection;
